<template>
  <div>
    <div class="row mb-3" v-for="(item, index) in detail">
      <div class="col-1">{{index + 1}}</div>
      <div class="col-3">
        <h5> نام محصول: {{item.productName}}</h5>
      </div>
      <div class="col-2">
        <h5>تعداد: {{item.unitVal}}</h5>
      </div>
      <div class="col-2">
        <h5>در دست تولید: {{item.worksCount}}</h5>
      </div>
      <div class="col-2">
        <h5>واحد: {{item.unitName}}</h5>
      </div>
      <div class="col-2">
        <button class="btn btn-warning">
          <component :order-detail="item" :is="currentComp"></component>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

    import VsSelect from "../_framework/VsSelect";
    import VsTable from "../_framework/VsTable.vue";
    import BaseService from "../_framework/api/BaseService.js";
    import WorkChart from "../components/WorkChart.vue";
    import WorkStatus from "../components/WorkStatus.vue";
    import WorkDetailsModal from "../components/WorkDetailsModal"
    import EventBus from "../bus.js";
    // import * as $ from 'jquery';
    import {mapState} from "vuex";
    import * as Vue from "vue";
    import {bus} from '../main';
    import EditCustomerOrder from "./EditCustomerOrder";


    export default {
        name: 'order-details',
        props: ['row'],
        components: {
            VsSelect,
            VsTable,
            WorkChart,
            WorkStatus,
            /* WorkDetailsModal : {
               template: `<work-details-modal></work-details-modal>`
             }*/
            'WorkDetailsModal': WorkDetailsModal,
            'EditCustomerOrder': EditCustomerOrder
        },

        data() {
            return {
                workDetailsModal: {
                    template: `<work-details-modal></work-details-modal>`
                },
                EditCustomerOrder: {
                    template: `<edit-customer-order></edit-customer-order>`
                },
                orderId: 0,
                currentComp: 'WorkDetailsModal',
                editComp: 'EditCustomerOrder',
                isCompleted: [],
                innerWorkDetails: {},
                workDetail: [],
                productName: null,
                orderDetail: [],
                detail: [],
                createPatternModel: {
                    patternId: 0,
                    count: null,
                    orderDetailId: 0
                },
                params: {
                    entity: "details",
                    list: [],
                    headers: {
                        code: {
                            title: "کد",
                            type: "text",
                            rowAlignment: "center"
                        },
                        completed: {
                            title: "تکمیل شده",
                            type: 'custom',
                            component: WorkStatus,
                            rowAlignment: "center"
                        },
                        workChart: {
                            title: 'جزئیات',
                            type: 'custom',
                            component: WorkChart,
                            rowAlignment: 'center',
                            inHeader: true
                        },
                    }
                },
                options: {
                    dataSourceType: "store",
                    hasActions: false,
                    onRowClicked: row => {
                    },
                    hasActionsInHeader: true,
                    clickableRows: true,
                    onCreateHeaderActionClicked: false,
                    onEditClicked: (row, context) => {
                        this.productOrderModel = row;
                        this.productOrderModel.mode = "edit";
                        this.openProductDetailModal();
                    },onPasteClicked: (row, context) => {
                        this.productOrderModel = row;
                        this.productOrderModel.mode = "edit";
                        this.openProductPasteModal();
                    },
                    onRowDoubleClicked: row => {
                        this.productOrderModel = row;
                        this.productOrderModel.mode = "view";
                        this.openProductDetailModal();
                    },
                    beforeDeleteEntity: input => {
                        this.deleteOrdersTableRow(input.id);
                        return null;
                    }
                }
            }
        },
        mounted() {
            // console.log("row is : " + this.row);
            this.orderDetail.push(this.row.orders);
            for (let item of this.orderDetail) {
                for (let val of item)
                    this.detail.push(val);
            }
            for (let item of this.detail) {
                // console.log(item);
                this.productName = item.productName;
                setTimeout(() => {
                    localStorage.setItem('productName', this.productName)
                }, 1000)
            }
        },
        created() {
            bus.$on('switchComp', comp => {
                // console.log(comp);
                this.currentComp = comp;
                this.editComp = comp;
            })
        },
        methods: {},
        computed: {
            ...mapState(["vsTableFeed"])
        },
    }

</script>

<style scoped lang="scss">
  .black {
    color: black;
  }
</style>
